.page {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-2);
}

.header {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.title {
  font-size: var(--tuna-typography-h4-fontSize);
  margin: 0;
}

.pickers {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}
